import React from "react";
import PropTypes from "prop-types";
import { FaPlus } from "@react-icons/all-files/fa6/FaPlus";
import { FaMinus } from "@react-icons/all-files/fa6/FaMinus";
import { IoPeopleOutline } from "@react-icons/all-files/io5/IoPeopleOutline";
import { Button } from "day8-ui";
import { getSelectedCabinsCrewText, getSelectedFilters } from "../../../../helpers/filter";
import { CABIN, CREW } from "../../../../constants";
import history from "../../../../history";
import { getAvailableCabinsTypes } from "../../../../helpers/week";
import { useDispatch, useSelector } from "react-redux";
import { getCabinOptionTitle, getCabinOptionDescription } from "../../../../helpers/cabinLabels";
import { updateSearch } from "../../../../helpers/querystring";

const CabinsCrewFilter = props => {
  const dispatch = useDispatch();
  const cabins = useSelector(state => state.cabins.data);
  const selectedFilters = getSelectedFilters(history.location);
  const availableCabinTypes = getAvailableCabinsTypes(cabins, selectedFilters.destinationFilter);
  const cabinTypesCount = selectedFilters.cabinType?.length || 0;
  const soloTypesCount = selectedFilters.soloType?.length || 0;
  const totalSelectedGuests = cabinTypesCount * 2 + soloTypesCount;
  const selectedFilterText = getSelectedCabinsCrewText() || 'Selected Cabins';
  const handleSelection = (cabinType, genderType, operator) => {
    const filteredSelectedCabins = selectedFilters[`${cabinType}Type`];
    const index = filteredSelectedCabins && filteredSelectedCabins.indexOf(genderType);
    if (operator === 1) filteredSelectedCabins.push(genderType);
    if (operator === -1) filteredSelectedCabins.splice(index, 1);
    history.replace({
      pathname: location.pathname,
      search: updateSearch(history.location, {
        [`${cabinType}Type`]: filteredSelectedCabins
      })
    });
    // here using location from history which was just updated
    dispatch(props.filterAction(history.location));
  };
  if (!availableCabinTypes) {
    return null;
  }
  return props.mobile ? (
    <div className={`dui-flex dui-flex-col dui-gap-4 ${props.className}`}>
      <AvailableCabinOptions availableCabinTypes={availableCabinTypes} selectedFilters={selectedFilters} totalSelectedGuests={totalSelectedGuests} handleSelection={handleSelection} error={!totalSelectedGuests} />
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<IoPeopleOutline />}>{selectedFilterText || 'Cabins Crew'}</Button>;
};
CabinsCrewFilter.propTypes = {
  weeks: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  filterAction: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default CabinsCrewFilter;

// Factored this out to be reusable in mobile/desktop parts
const AvailableCabinOptions = ({ availableCabinTypes = [], selectedFilters = {}, totalSelectedGuests, handleSelection, error }) => availableCabinTypes.map((item, i) => {
  if (availableCabinTypes.length < 1) return null;
  const type = item.type;
  const isSoloCabin = item.persons === 1 && item.cabinType === CABIN.CABIN_TYPE;
  const genderType = `${type}${isSoloCabin ? 'Solo' : ''}`;
  const count = selectedFilters[`${item.cabinType}Type`] && selectedFilters[`${item.cabinType}Type`].filter(i => i === genderType).length;
  const title = getCabinOptionTitle(item);
  const description = getCabinOptionDescription(item);
  return (
    <div key={i} className="dui-flex dui-justify-between dui-items-center dui-gap-8">
      <div className="dui-min-w-0">
        <div className="dui-flex dui-items-start">
          <IoPeopleOutline className="dui-flex-shrink-0 dui-mt-1" />
          <p className="dui-font-bold dui-ml-2">{title}</p>
        </div>
        {description && <p className="dui-text-primary-900">{description}</p>}
      </div>
      <div className="dui-flex dui-items-center dui-gap-4 dui-flex-shrink-0">
        <Button className={error && 'dui-outline-red-500 dui-border-red-500'} buttonType="SECONDARY" buttonSize="EXTRA_SMALL" rightIcon={<FaMinus />} onClick={() => handleSelection(item.cabinType, genderType, -1)} disabled={count === 0} />
        <span className={error && 'dui-text-red-500'}>{count}</span>
        <Button className={error && 'dui-outline-red-500 dui-border-red-500'} buttonType="SECONDARY" buttonSize="EXTRA_SMALL" rightIcon={<FaPlus />} onClick={() => handleSelection(item.cabinType, genderType, +1)} disabled={totalSelectedGuests >= CREW.MAX_GUESTS_ALLOWED_ON_CABIN_BOOKING} />
      </div>
    </div>
  );
});